module.exports = __webpack_public_path__ + "fonts/Roboto-Light.1eaee99.eot";